import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_sftp_pushService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { connection: string, target_path: string, transit_path?: string, transaction_id?: string, files: { file_name?: string, file_blob?: any }[] }): Promise<{ messages?: any[], success?: boolean }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.connection)) {
      $missingRequiredInParams.push('\'connection\'');
    }
    if (isNil($inParams.target_path)) {
      $missingRequiredInParams.push('\'target_path\'');
    }
    if (isNil($inParams.files)) {
      $missingRequiredInParams.push('\'files\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

